import { useState,useEffect } from 'react';
import { Card, CardContent, Grid, makeStyles, Button } from '@material-ui/core';
import {Theme,withStyles,Dialog,createStyles } from '@material-ui/core';

import { useSelector, useDispatch } from 'react-redux';
import UtilService from "../../../../../helper/service";
import { getStripeProductsList} from "../../../../../store/actions/admin/user";
import PurchaseSubscriptionModal from "../../../../atoms/modals/PurchaseSubscriptionModal"
import UpgradeSubscriptionModal from "../../../../atoms/modals/UpgradeSubscriptionModal"
import AddUserLicences from "../../../../atoms/modals/AddUserLicences"
import SuccessModal from '../../../../atoms/modals/successModal';
import {BackDropAnalyzeLoading } from '../../../../atoms/commonLoadings';
import Config from "../../../../../config/config";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { Link } from "react-router-dom";
import axios from 'axios'
const auth_token = localStorage.getItem("auth_token")
const idToken = localStorage.getItem("idToken")
import AddCardDetailModal from "../../../../atoms/modals/AddCardDetailModal"
import * as ImmersionGQL from "../../../../../gql";


const styles = (theme: Theme) =>
  createStyles({
      root: {
          // margin: 0,
          // padding: theme.spacing(2),
          // paddingTop: 26
      },
      closeButton: {
          position: 'absolute',
          right: theme.spacing(1),
          background: 'transparent !important',
      },
      header: {
          color: '#212D40',
          fontFamily: 'Spartan-bold',
          fontSize: 18,
          padding: 10,
          display: 'flex',
          alignItems: 'center'
      }
  });

const useStyles = makeStyles({
  root: {
    marginBottom: 20,
    borderRadius: 10
  },
  paper: {
    borderRadius: '10px !important'
  },
  planTxt:{
    marginTop: '-30px !important',
    position: 'absolute',
    fontFamily: 'roboto-regular',
    marginLeft: '21px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  greyBtn:{
    color: "#697683",
    fontFamily: 'roboto-regular',
  },
  linkText: {
    color: '#017aef',
    cursor: 'pointer',
    fontFamily: 'roboto-regular',
  },
  table: {
    minWidth: 650,
  },
  btn:{
    fontFamily: 'roboto-regular',
    textTransform:"initial"
  },
  cancelTxt: {
    color: 'red',
    fontSize:15,
    fontFamily: 'roboto-regular',
  },
  
});

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
    <div className={classes.header}>
      {children}
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'}/>
        </IconButton>
      ) : null}
    </div>
  </MuiDialogTitle>
  );
});
const SimpleBillingComponent = (details:any) => {
  let billingdetail: any = [];
  let users: any = [];
  let roles: any = [];
  
  let trial_period = 0;
  let active_users_count = 0;
  
  
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [cardAddPopup, setCardAddPopup] = useState(false);
  const [upgradePopup, setUpgradePopup] = useState(false);
  const [addLicencePopp, setAddLicencePopup] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [portalUrl, setPortalUrl] = useState('');
  const [message, setMessage] = useState('');
  const [isAnyActiveSubsciption, setisAnyActiveSubsciption] = useState(false);

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const { stripeCustomerDetail} = useSelector((state: any) => state.adminUser);
  const dispatch = useDispatch();
  const [isOpenChargePopup, setisOpenChargePopup] = useState(false);
  const [stripeMode, setStripemode] = useState('TEST');



  const closeChargeModal = () => {
    setisOpenChargePopup(false)
  };
  const openChargeModal = () => {
    setisOpenChargePopup(true)
  };
  useEffect(() => {
      if (stripeCustomerDetail && stripeCustomerDetail.subscriptionsList && stripeCustomerDetail.subscriptionsList.length) {
        if(details && details.details && details.details['billingDetails'].data && details.details['billingDetails'].data.stripe_subscription_id){
          const filteredSub = stripeCustomerDetail.subscriptionsList.filter(function(obj: any) {
              if (obj.id === details.details['billingDetails'].data.stripe_subscription_id && obj.status ==="active") {
                  return obj
              }
          });
          if(filteredSub.length > 0){
            setisAnyActiveSubsciption(true);
            console.log(isAnyActiveSubsciption);
          }
        }
        getStripePortalUrl();
      }
  }, [stripeCustomerDetail])

  useEffect(() => {
    dispatch(getStripeProductsList(apolloClient.client));
  }, [apolloClient.client, dispatch, loginUserData.user_id]);
  useEffect(() => {
    getStripeMode()
  }, []);
  
  /*useEffect(() => {
    getStripePortalUrl()
  }, []);
  */

  if(details && details.details){
    billingdetail = details.details['billingDetails'].data;
    const  temp_trial_period = UtilService.calculateTrialDays(billingdetail.pay_started_at);
    trial_period = billingdetail.billing_period  - temp_trial_period;
    if(trial_period < 0){
      trial_period = 0;
    }
    
   
    users = details.details['users'];
    roles = details.details['roles'];
    

    const admin_roleid = roles ? roles.filter((val:any) => val.role_name === "admin")[0] : {role_id: "0"};
    const creator_roleid = roles ? roles.filter((val:any) => val.role_name === "creator")[0] : {role_id: "0"};
    const subscriber_roleid = roles ? roles.filter((val:any) => (val.role_name === "subscriber" || val.role_name === "subscriberclever" || val.role_name === "subscribersmart" || val.role_name === "subscribergenius")) : [{role_id: "0"}];

    const isuseradmin = (loginUserData && loginUserData.role_access) ? loginUserData.role_access.filter((val:any) => val.access_name === "admin_users") : null;
    const isusertrialadmin = (loginUserData && loginUserData.role_access) ? loginUserData.role_access.filter((val:any) => val.access_name === "trial_admin") : null;
    const system_flagged = loginUserData ? loginUserData.system_flagged : false;

    //console.log(loginUserData);

    if(system_flagged == true){
      active_users_count = users.length;
    }else {
      users.map((val: any) => {
        if(val.department_id == loginUserData.department_id && val.active===true){
          if(isuseradmin && isuseradmin[0].access_value){
            if(val.role_id == admin_roleid.role_id || val.role_id == creator_roleid.role_id){
              active_users_count++;
            }
          }else if(isusertrialadmin && isusertrialadmin[0].access_value && val.active===true){
            if(val.role_id == loginUserData.role_id  || subscriber_roleid.filter((v:any) => v.role_id == val.role_id)[0]){
              active_users_count++;
            }
          }
        }
      })
    }
    billingdetail.active_users_count = active_users_count

    
  }
  


  const gotoPortal = () => {
    if (portalUrl != '') {
      window.location.href=portalUrl;
    }
  }


  const getStripePortalUrl = async () => {

    if (billingdetail && billingdetail.stripe_customer_id) {
 
      apolloClient.client.query({
        query: ImmersionGQL.getStripePortal,
        fetchPolicy: "no-cache",
        variables: {
          customerid: billingdetail.stripe_customer_id
        }
      })
      .then((response: any) => {

        if (response.data.getStripePortal.status === "true") {
          setPortalUrl(response.data.getStripePortal.data.url);
        }
      });
    }



  
}


  const getStripeMode = async () => {
        
        await axios.post(Config.API_URL, {
            query: `query getStripeMode{
                      getStripeMode{
                        data status message data
                      }
                    }`
        }, {
            headers: {
                accesstoken: auth_token ? auth_token : "",
                schemaname: "public",
                idToken: idToken ? idToken : ""
            }
        }).then(async (result:any) => {
            if(result.data.data.getStripeMode.status === "true"){
              setStripemode(result.data.data.getStripeMode.data.stripe_mode)
            }
        }).catch(( ) => {
          
        });
    }

  const closeBuyNowPopup = () =>{
    setPopUpOpen(false);
    setSelectedPlan('')
  }
  

  const closeUpgradePopup = () =>{
    setUpgradePopup(false);
    setSelectedPlan('')
  }

  const closeAddLicencePopup = () =>{
    setAddLicencePopup(false);
    setSelectedPlan('')
  }

  

  
  const classes = useStyles();
  
  const openCloseSuccessModal = (msg:any) => {
    setsuccessModal(!successModal);
    setMessage(msg)
  };

  const closeAddcardPopup = () =>{
    setCardAddPopup(false);
  }
  

  
  return (

    <>
      {<BackDropAnalyzeLoading loading={details && details.loader?true:false} />}
      {popUpOpen &&
        <PurchaseSubscriptionModal
          stripe_mode={stripeMode}
          onClose={closeBuyNowPopup}
          open={popUpOpen}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
          openCloseSuccessModal={openCloseSuccessModal}
        />
      }
      {cardAddPopup &&
        <AddCardDetailModal
          stripe_mode={stripeMode}
          onClose={closeAddcardPopup}
          open={cardAddPopup}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
        />
      }
      {upgradePopup &&
        <UpgradeSubscriptionModal
          stripe_mode={stripeMode}
          onClose={closeUpgradePopup}
          open={upgradePopup}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
          openCloseSuccessModal={openCloseSuccessModal}
        />
      }
      {addLicencePopp &&
        <AddUserLicences
          stripe_mode={stripeMode}
          onClose={closeAddLicencePopup}
          open={addLicencePopp}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
          openCloseSuccessModal={openCloseSuccessModal}
        />
      }
      {successModal && 
        <SuccessModal
          successModal={successModal}
          openCloseSuccessModal={openCloseSuccessModal}
          message={message}
        />
      }


    <Card className={`billing-container ${classes.root}`} variant="outlined">
        <CardContent>
          
          <Grid container className="w-50">
            <Grid item lg={10} md={10} sm={10} xs={12} >
            <div className="billing-header">
                <p className="main-title">Current Plan: {(loginUserData.role_name.toLowerCase() == 'clever') ? "Clever" : (loginUserData.role_name.toLowerCase() == 'smart') ? "Smart" : (loginUserData.role_name.toLowerCase() == 'genius') ? "Genius" : "" }</p>
                
              </div>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={12} style={{textAlign:'right'}}>
              <div>
                
              </div>
            </Grid>
          </Grid>
          

          <Grid container className="w-50">
            <Grid item lg={10} md={10} sm={10} xs={12} >
            <div className="billing-header">
                
                <p>If you have questions about your subscription or would like to speak with a person on our accounts team, <a href={ `mailto:${Config.billing.email}` }>contact us</a>.</p>
              </div>
            </Grid>
          </Grid>


        </CardContent>
    </Card>

    <Card className={`billing-container ${classes.root}`} variant="outlined">
        <CardContent>
          
          <Grid container className="w-50">
            <Grid item lg={10} md={10} sm={10} xs={12} >
            <div className="billing-header">
                <p className="main-title">Manage Your Billing Details</p>
                
              </div>
            </Grid>
          </Grid>

          <Grid container className="w-50">
            <Grid item lg={10} md={10} sm={10} xs={12} >
            <div className="billing-header">
                
                <p>Your billing details (subscription, credit card, billing history, etc.) are all managed by Stripe.  Click the button below to manage your account.</p>
              </div>
            </Grid>
          </Grid>

          <Grid container className="w-50">
            <Grid item lg={10} md={10} sm={10} xs={12} >
            <div className="billing-header">
            <Button variant="contained" className={classes.btn} onClick={() => gotoPortal()} color="primary">Open Stripe Portal</Button>&nbsp;&nbsp;
            <Button variant="contained" className={classes.btn} onClick={() => openChargeModal()} color="default">View Charge History</Button>
              </div>
            </Grid>
          </Grid>


        </CardContent>
    </Card>

      
      
        
        <Dialog
          disableEscapeKeyDown
          fullWidth={true}
          maxWidth={'md'}
          scroll='paper'
          open={isOpenChargePopup}
          classes={{
            paper: classes.paper
          }}
        >
          <DialogTitle onClose={closeChargeModal}>Charges History</DialogTitle>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Amount</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Statement Descriptor</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Receipt URL</TableCell>
                  <TableCell align="center">Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stripeCustomerDetail && stripeCustomerDetail.charges && stripeCustomerDetail.charges.length && 
                  stripeCustomerDetail.charges.map((val:any) => (
                  <TableRow key={val.id}>
                    <TableCell component="th" scope="row">
                      {"$" + (val.amount) / 100}
                    </TableCell>
                    <TableCell align="center">{val.description?val.description:"-"}</TableCell>
                    <TableCell align="center">{val.statement_descriptor?val.statement_descriptor:"-"}</TableCell>
                    <TableCell align="center">{val.status.charAt(0).toUpperCase() + val.status.slice(1)}</TableCell>
                    <TableCell align="center">
                      <Link  color="inherit" to={{pathname:val.receipt_url}}   target='_blank'>Receipt URL</Link>
                     </TableCell>
                    <TableCell align="center">{val.created ? moment.unix(val.created).format("MM/DD/YYYY hh:mm A") : ""}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
      
    </>
  )
}
export default SimpleBillingComponent;

